define("ember-svg-jar/inlined/media", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.6 2.443H2.4a.457.457 0 00-.457.457v11.2c0 .252.204.457.457.457h2.23l6.29-6.29 3.137 3.137V2.9a.457.457 0 00-.457-.457zm.457 10.982l-3.138-3.138-4.27 4.27h6.95a.457.457 0 00.458-.457v-.675zM2.4 1.07C1.39 1.071.57 1.89.57 2.9v11.2c0 1.01.819 1.828 1.829 1.828h11.2c1.01 0 1.828-.818 1.828-1.828V2.9c0-1.01-.818-1.829-1.828-1.829H2.4zm2.899 3.273c-1.148 0-2.026.878-2.026 2.026 0 1.148.878 2.026 2.026 2.026 1.148 0 2.026-.878 2.026-2.026 0-1.148-.878-2.026-2.026-2.026zm0 2.701c-.406 0-.676-.27-.676-.675s.27-.675.676-.675c.405 0 .675.27.675.675s-.27.675-.675.675z\"/>",
    "attrs": {
      "width": "16",
      "height": "17",
      "viewBox": "0 0 16 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});